// extracted by mini-css-extract-plugin
var _1 = "ChapterPathRoom__demo--Jjw7A";
var _2 = "ChapterPathRoom__finalAcademyBadgeHitBox--GnEEh";
var _3 = "ChapterPathRoom__finalAcademyBadgeLayer--oU6q1";
var _4 = "ChapterPathRoom__grade1--XfCok";
var _5 = "ChapterPathRoom__grade2--CpLGw";
var _6 = "ChapterPathRoom__grade3--iWYdX";
var _7 = "ChapterPathRoom__grade4--qeJiF";
var _8 = "ChapterPathRoom__grade5--HYX3D";
var _9 = "ChapterPathRoom__higher--OFVVI";
var _a = "ChapterPathRoom__hoverBox--CD_rj";
var _b = "ChapterPathRoom__hoverEffect--FqKVZ";
var _c = "ChapterPathRoom__locked--U4WhG";
var _d = "ChapterPathRoom__main--ArvLq";
var _e = "ChapterPathRoom__mainButton--XyYRt ChapterPathRoom__main--ArvLq";
var _f = "ChapterPathRoom__mask--bRx8k";
var _10 = "ChapterPathRoom__north--fl4Cx";
var _11 = "ChapterPathRoom__northLesson--o2gXC";
var _12 = "ChapterPathRoom__northReading--MziFW";
var _13 = "ChapterPathRoom__room--lTXTb ChapterPathStyles__antiSeams--XNFsH ChapterPathStyles__antiLag--A6PV1";
var _14 = "ChapterPathRoom__south--Wjjuk";
var _15 = "ChapterPathRoom__southLesson--i8QmY";
var _16 = "ChapterPathRoom__southReading--JvKXk";
var _17 = "ChapterPathRoom__subtitle--RFMMx";
var _18 = "ChapterPathRoom__teacher--ondiA";
var _19 = "ChapterPathRoom__teacherImg--VwXjz ChapterPathStyles__antiLag--A6PV1";
var _1a = "ChapterPathRoom__test--DSzNc";
var _1b = "ChapterPathRoom__title--WbQhh TrainerGeneral__robotoSlabMedium--zxA53 CoreGeneral__robotoSlabMedium--f2t8p";
var _1c = "ChapterPathRoom__unlocked--C62C6";
export { _1 as "demo", _2 as "finalAcademyBadgeHitBox", _3 as "finalAcademyBadgeLayer", _4 as "grade1", _5 as "grade2", _6 as "grade3", _7 as "grade4", _8 as "grade5", _9 as "higher", _a as "hoverBox", _b as "hoverEffect", _c as "locked", _d as "main", _e as "mainButton", _f as "mask", _10 as "north", _11 as "northLesson", _12 as "northReading", _13 as "room", _14 as "south", _15 as "southLesson", _16 as "southReading", _17 as "subtitle", _18 as "teacher", _19 as "teacherImg", _1a as "test", _1b as "title", _1c as "unlocked" }
